export const TOGGLE_CUSTOMER_ONBOARDING_POPUP = 'application/TOGGLE_CUSTOMER_ONBOARDING_POPUP';
export const START_TOUR_MODE = 'application/START_TOUR_MODE';
export const SET_TOUR_MODE = 'application/SET_TOUR_MODE';

export const startTourMode = () => ({
  type: START_TOUR_MODE
});

export const setTourMode = (mode) => ({
  type: SET_TOUR_MODE,
  payload: mode
});

export const toggleCustomerOnboardingPopup = (visible) => ({
  type: TOGGLE_CUSTOMER_ONBOARDING_POPUP,
  payload: visible
});
